// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__RctwC","name":"ConsentHeader_name__18b7A","birthday":"ConsentHeader_birthday__CFcJb","skeleton":"ConsentHeader_skeleton__2Jao-"};